import { useEffect } from 'react';

// Sets <title>, meta description, and canonical URL per page (client-side).
// Modern crawlers (Google, Bing) render JS so these are picked up for SEO.
export const useSEO = ({ title, description, path }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = 'name') => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');

    if (path) {
      const url = `https://maisiagalagroup.com${path}`;
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
      setMeta('og:url', url, 'property');
    }
  }, [title, description, path]);
};
